import React, { Component, ErrorInfo, ReactNode } from "react";
import { isSSR } from "../utils/ssr";

interface ErrorBoundaryProps {
  sendToRollbar?: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {
  static defaultProps: ErrorBoundaryProps = {
    sendToRollbar: true
  };

  state = {
    error: null
  };

  componentDidCatch(error: Error, _errorInfo: ErrorInfo): void {
    console.debug("Error Boundary");
    console.error(error);

    // Log the error to an error reporting service
    if (!isSSR() && window.rollbar && this.props.sendToRollbar)
      window.rollbar.error(error);
  }

  render(): ReactNode {
    if (this.state.error) {
      // You can render any custom fallback UI
      return <></>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
